"use strict";

( function( namespace ) {
	/**
	* Check if script is loaded.
	* @param {string} src - Script source.
	* @returns {bool}
	*/
	namespace.isScriptLoaded = function( src ) {
		var scripts = document.getElementsByTagName( "script" );

		for ( var i = 0; i < scripts.length; i++ ) {
			if ( scripts[ i ].getAttribute( "src" ) === src ) {
				return true;
			}
		}

		return false;
	};

	/**
	* Load script and run callback when it is loaded.
	* @param {string} src - Script source.
	* @param {function} callback - Callback function.
	*/
	namespace.loadScript = function( src, callback ) {
		var scriptEl, scriptTags;

		if ( namespace.isScriptLoaded( src ) ) {
			if ( callback ) {
				callback();
			}

			return;
		}

		scriptEl = document.createElement( "script" );
		scriptEl.setAttribute( "type", "text/javascript" );
		scriptEl.setAttribute( "src", src );

		if ( callback ) {
			scriptEl.onload = callback;
		}

		scriptTags = document.getElementsByTagName( "script" );
		scriptTags[ 0 ].parentNode.insertBefore( scriptEl, scriptTags[ 0 ] );
	};

	/**
	* Check if stylesheet is loaded.
	* @param {string} src - Stylesheet source.
	* @returns {bool}
	*/
	namespace.isStyleSheetLoaded = function( src ) {
		var links = document.getElementsByTagName( "link" );

		for ( var i = 0; i < links.length; i++ ) {
			if ( links[ i ].getAttribute( "href" ) === src ) {
				return true;
			}
		}

		return false;
	};

	/**
	* Load stylesheet and run callback when it is loaded.
	* @param {string} src - Stylesheet source.
	* @param {function} callback - Callback function.
	*/
	namespace.loadStyleSheet = function( src, callback ) {
		var styleEl, headTag;

		if ( namespace.isStyleSheetLoaded( src ) ) {
			if ( callback ) {
				callback();
			}

			return;
		}

		styleEl = document.createElement( "link" );
		styleEl.setAttribute( "rel", "stylesheet" );
		styleEl.setAttribute( "type", "text/css" );
		styleEl.setAttribute( "href", src );

		if ( callback ) {
			styleEl.onload = callback;
		}

		headTag = document.getElementsByTagName( "head" );
		headTag[ 0 ].appendChild( styleEl );
	};

	/**
	* Return true when DOM is ready to be queried.
	* @returns {bool}
	*/
	namespace.isDOMReady = function() {
		return document.readyState === "complete" || document.readyState === "interactive";
	};

	/**
	* Check if waitFor is true and run thenRun function.
	* If waitFor is false, keep waiting until timeout is reached.
	* @param {function} waitFor - Stylesheet source.
	* @param {function} thenRun - Callback function.
	*/
	namespace.waitForThenRun = function( waitFor, thenRun, fail ) {
		if ( !waitFor || !thenRun ) {
			return;
		}

		if ( waitFor() ) {
			thenRun();
			return;
		}

		( function() {
			var startTime = Date.now();

			var waitForThenRunInternal = function( waitForInternal, thenRunInternal, failInternal ) {
				if ( waitForInternal() ) {
					thenRunInternal();
					return;
				}

				if ( ( Date.now() - startTime ) > namespace.getTimeout() ) {
					if ( failInternal ) {
						failInternal();
					}
					return;
				}

				setTimeout( waitForThenRunInternal, 100, waitForInternal, thenRunInternal, failInternal );
			};

			waitForThenRunInternal( waitFor, thenRun, fail );
		} )();
	};

	/**
	* Check if element contains a class name.
	* @param {object} el - Element to be checked.
	* @param {string} className - Class name.
	* @returns {bool}
	*/
	namespace.hasClass = function( el, className ) {
		var classes = el.className.split( " " );
		return classes.indexOf( className ) > -1;
	};

	/**
	* Append class name to element.
	* @param {object} el - Element to be changed.
	* @param {string} className - Class name.
	*/
	namespace.addClass = function( el, className ) {
		var classes = el.className.split( " " );
		classes.push( className );
		el.className = classes.join( " " );
	};

	/**
	* Remove class name from element.
	* @param {object} el - Element to be changed.
	* @param {string} className - Class name.
	*/
	namespace.removeClass = function( el, className ) {
		var classes = el.className.split( " " );
		var index = classes.indexOf( className );
		if ( index > -1 ) {
			classes.splice( index, 1 );
			el.className = classes.join( " " );
		}
	};

	/**
	* Perform a XHR request and run callback on success.
	* @param {string} url - GET URL.
	* @param {function} callback - Callback function, takes a responseText argument.
	* @param {function} error - Callback error function.
	*/
	namespace.xhrGet = function( url, callback, error ) {
		var xhr = new XMLHttpRequest();

		xhr.open( "GET", url );

		xhr.onload = function() {
			if ( xhr.status === 200 ) {
				if ( callback ) {
					callback( xhr.responseText );
				}
			} else {
				videojs.log( "XHR GET " + xhr.status + " " + url );
			}
		};

		if ( error ) {
			xhr.onerror = error;
		}

		xhr.send();
	};

	/**
	* Perform a XHR head request and run callback on success.
	* @param {string} url - GET URL.
	* @param {function} callback - Callback function, takes a boolean argument.
	*/
	namespace.xhrHead = function( url, callback ) {
		var xhr = new XMLHttpRequest();
		xhr.open( "HEAD", url );
		xhr.timeout = 2000;

		xhr.onload = function() {
			if ( callback ) {
				callback( xhr.status === 200 );
			} else {
				videojs.log( "XHR HEAD " + xhr.status + " " + url );
			}
		};

		xhr.ontimeout = function() {
			if ( callback ) {
				callback( false );
			} else {
				videojs.log.error( "XHR HEAD timeout" );
			}
		};

		xhr.send();
	};

	/**
	* Check if element is poster media.
	* @param {object} el - Element to be checked.
	* @returns {bool}
	*/
	namespace.isPosterMedia = function( el ) {
		var parent = el.parentNode;
		if ( parent ) {
			if ( namespace.hasClass( parent, "article-poster-media" ) || namespace.hasClass( parent, "article-poster-media-nowcast" ) ) {
				return true;
			}
		}
		return false;
	};

	/**
	* Check if element is inside the viewport.
	* @param {object} el - Element to be checked.
	* @returns {bool}
	*/
	namespace.isInViewport = function( el ) {
		var rect = el.getBoundingClientRect();
		var html = document.documentElement;

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= ( window.innerHeight || html.clientHeight ) &&
			rect.right <= ( window.innerWidth || html.clientWidth )
		);
	};

	/**
	* Check if browser is Safari.
	* @returns {bool}
	*/
	namespace.isBrowserSafari = function() {
		var isSafari = navigator.vendor &&
			navigator.vendor.indexOf( "Apple" ) > -1 &&
			navigator.userAgent &&
			!navigator.userAgent.match( "CriOS" );

		return isSafari;
	};

	/**
	* Check if browser is Edge.
	* @returns {bool}
	*/
	namespace.isBrowserEdge = function() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf( "MSIE " );
		if ( msie > 0 ) {
			// IE 10 or older => return version number
			return parseInt( ua.substring( msie + 5, ua.indexOf( ".", msie ) ), 10 );
		}

		var trident = ua.indexOf( "Trident/" );
		if ( trident > 0 ) {
			// IE 11 => return version number
			var rv = ua.indexOf( "rv:" );
			return parseInt( ua.substring( rv + 3, ua.indexOf( ".", rv ) ), 10 );
		}

		var edge = ua.indexOf( "Edge/" );
		if ( edge > 0 ) {
			// Edge (IE 12+) => return version number
			return parseInt( ua.substring( edge + 5, ua.indexOf( ".", edge ) ), 10 );
		}

		return false;
	};

	/**
	* Check and append resize and output quality parameters to URL.
	* @param {string} url - URL to be checked.
	* @returns {string}
	*/
	namespace.resizePoster = function( url ) {
		if ( !url ) {
			return null;
		}

		var urlHasQuestionMark = url.indexOf( "?" ) > -1;
		var queryString = urlHasQuestionMark ? url.substring( url.indexOf( "?" ) + 1 ) : "";

		var keys = [];
		var queryList = urlHasQuestionMark ? queryString.split( "&" ) : [ queryString ];

		for ( var i = 0; i < queryList.length; i++ ) {
			var pair = queryList[ i ].split( "=" );
			if ( pair.length > 0 && pair[ 0 ] ) {
				keys.push( pair[ 0 ] );
			}
		}

		if ( keys.indexOf( "resize" ) > -1 || keys.indexOf( "output-quality" ) > -1 ) {
			return url;
		}

		return url + ( urlHasQuestionMark ? "&" : "?" ) + "resize=810:*&output-quality=70";
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = 76
// module chunks = 0